export default __webpack_public_path__ + "static/media/trending-up.7952cc10.svg";